import { ListItemIcon, Menu as MenuMaterial, MenuItem, MenuProps } from '@mui/material';
import { styled } from '@mui/material';

import { Icon } from '~/components/ui/icon';
import { COLORS } from '~/styles/colors';

interface MenuItemOption {
  icon?: string;
  label: string;
  value: string | number;
}

type CustomMenuProps = Omit<MenuProps, 'onClose'> & {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  onSelect: (value: string | number) => void;
  items?: MenuItemOption[];
  transformOrigin?: any;
  anchorOrigin?: any;
  selectedValue?: string | number;
};

export default function Menu({
  anchorEl,
  open,
  handleClose,
  onSelect,
  items = [],
  transformOrigin,
  anchorOrigin,
  selectedValue,
}: CustomMenuProps) {
  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      transformOrigin={transformOrigin}
      anchorOrigin={anchorOrigin}
    >
      {items.map(({ icon, label, value }) => (
        <MenuItem selected={selectedValue === value} key={value} onClick={() => onSelect(value)}>
          {icon && (
            <ListItemIcon>
              <Icon withParentColor={false} size={20} icon={icon} />
            </ListItemIcon>
          )}
          {label}
        </MenuItem>
      ))}
    </StyledMenu>
  );
}

const StyledMenu = styled(MenuMaterial)(() => ({
  '& .MuiMenu-paper': {
    boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.05)',
    border: `1px solid ${COLORS.grey200}`,
    borderRadius: '20px',
  },
  '& .MuiMenu-list': {
    paddingBlock: '16px',
  },
}));
